import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'
import * as BufferActionTypes from '../buffers/actionTypes'
import * as IncidentActionTypes from '../incidents/actionTypes'

import { TWITTER_LAYER_ID } from '../constants'
import { getAIIdFromAttributes } from './selectors'

export const NAME = 'ai'

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.ai.forEach((ai) => {
        if (action.layerId === TWITTER_LAYER_ID) {
          if (ai.attributes.geo == null) {
            ai.geometry = null
          } else {
            ai.geometry.type = 'point'
            ai.geometry.x = ai.attributes.geo.coordinates[1]
            ai.geometry.y = ai.attributes.geo.coordinates[0]
          }
        }
        ai.layerId = action.layerId
        ai.id = getAIIdFromAttributes(action.layerId, ai.attributes)
        ai.attributes.id = ai.id
        byId[ai.id] = ai
      })
      return {
        ...state,
        [action.layerId]: byId,
      }
    case IncidentActionTypes.SELECT_INCIDENTS:
    case IncidentActionTypes.NEXT_INCIDENT:
    case IncidentActionTypes.PREV_INCIDENT:
    case IncidentActionTypes.CLEAR_SELECTION:
      return {}
    default:
      return state
  }
}

const allKeys = (state = {}, action) => {
  switch (action.type) {
    case BufferActionTypes.FETCH_SUCCESS:
      let layerLists = {}
      action.buffers.forEach((buffer) => {
        layerLists[buffer.AILayerId] = []
      })
      return layerLists
    case ActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        [action.layerId]: action.ai.map((ai) =>
          getAIIdFromAttributes(action.layerId, ai.attributes)
        ),
      }
    case IncidentActionTypes.SELECT_INCIDENTS:
    case IncidentActionTypes.NEXT_INCIDENT:
    case IncidentActionTypes.PREV_INCIDENT:
    case IncidentActionTypes.CLEAR_SELECTION:
      return {}
    default:
      return state
  }
}
const noAISelected = {
  ids: [],
  current: 0,
}

const selected = (state = noAISelected, action) => {
  switch (action.type) {
    case BufferActionTypes.SELECT:
      return {
        ids: [],
        current: 0,
      }
    case IncidentActionTypes.SELECT_INCIDENTS:
    case IncidentActionTypes.NEXT_INCIDENT:
    case IncidentActionTypes.PREV_INCIDENT:
    case IncidentActionTypes.CLEAR_SELECTION:
    case BufferActionTypes.DESELECT:
    case ActionTypes.DESELECT:
      return noAISelected
    case ActionTypes.SELECT:
      return {
        ...state,
        ids: action.ids,
        current: 0,
      }
    case ActionTypes.NEXT:
      return {
        ...state,
        current: state.current + 1,
      }
    case ActionTypes.PREV:
      return {
        ...state,
        current: state.current - 1,
      }
    default:
      return state
  }
}

const ai = combineReducers({
  byId,
  allKeys,
  selected,
})

export default ai
